import Image from "next/image";

export default function Logo({
  src,
  children,
}: {
  src: string | null;
  children?: React.ReactNode;
}) {
  return (
    <a href="/" className="h-[12px] dt:h-[16px] w-auto mx" id="logo">
      {src && (
        <Image
          src={src}
          loading="lazy"
          alt="Coach America"
          width={204}
          height={16}
          className="w-auto h-[12px] dt:h-[16px] max-w-none"
        />
      )}
    </a>
  );
}
